// import { Link } from "react-router-dom";
import React from 'react';
import { Link, useNavigate } from "react-router-dom";
import { MonitorSmartphone, Laptop, Smartphone, TabletSmartphone, ServerCog, Mail, Twitter, Linkedin, Github } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  

  const platforms = [
    { name: 'Windows', icon: MonitorSmartphone },
    { name: 'macOS', icon: Laptop },
    { name: 'iOS', icon: Smartphone },
    { name: 'Android', icon: TabletSmartphone },
    { name: 'Linux', icon: ServerCog }
  ];

  const scrollToSection = (sectionId) => {
  if (window.location.pathname !== "/") {
    navigate(`/#${sectionId}`);
  } else {
    document
      .getElementById(sectionId)
      ?.scrollIntoView({ behavior: "smooth" });
  }
};

  return (
    <footer className="bg-gray-900 text-gray-300 pt-16 pb-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-0">
              <div className="flex items-start gap-0">
              <img 
                src="/drivault-logo.png" 
                alt="Drivault" 
                className="h-10 w-10 object-contain"
              />

              <div className="flex flex-col leading-tight">
                <span className="text-2xl font-bold text-white">
                  Drivault
                </span>

                <p className="text-sm text-gray-300">
                  Safe to keep your data safe.
                </p>
              </div>
            </div>
            </div>
            {/* <p className="text-sm leading-relaxed ml-[41px]">
              Safe to keep your data safe.
            </p> */}
            <div className="flex items-center space-x-4 ml-10">
              <a href="#" className="hover:text-[#40E095] transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="hover:text-[#40E095] transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="hover:text-[#40E095] transition-colors">
                <Github size={20} />
              </a>
              <a href="#" className="hover:text-[#40E095] transition-colors">
                <Mail size={20} />
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="text-white font-bold mb-4">Product</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('features')} className="hover:text-[#40E095] transition-colors">
                  Features
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('pricing')} className="hover:text-[#40E095] transition-colors">
                  Pricing
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('how-it-works')} className="hover:text-[#40E095] transition-colors">
                  How It Works
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('faq')} className="hover:text-[#40E095] transition-colors">
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          {/* Download Links */}
          <div>
            <h3 className="text-white font-bold mb-4">Download</h3>
            <ul className="space-y-3">
              {platforms.map((platform) => {
                const IconComponent = platform.icon;
                return (
                  <li key={platform.name}>
                    <a href="#" className="flex items-center space-x-2 hover:text-[#40E095] transition-colors">
                      <IconComponent size={16} />
                      <span>{platform.name}</span>
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
<div>
  <h3 className="text-white font-bold mb-4">Legal</h3>

  <ul className="space-y-3">
    <li>
      <Link
        to="/privacy-policy"
        className="hover:text-[#40E095] transition-colors"
      >
        Privacy Policy
      </Link>
    </li>

    <li>
      <Link
        to="/terms-of-service"
        className="hover:text-[#40E095] transition-colors"
      >
        Terms of Service
      </Link>
    </li>

    <li>
      <Link
        to="/cookie-policy"
        className="hover:text-[#40E095] transition-colors"
      >
        Cookie Policy
      </Link>
    </li>

    <li>
      <Link
        to="/contact-us"
        className="hover:text-[#40E095] transition-colors"
      >
        Contact Us
      </Link>
    </li>
  </ul>
</div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm">
              © {currentYear} Drivault. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
